import { useEffect } from "react";
import Lenis from "lenis";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Statement from "@/components/landing/Statement";
import PartnerSplit from "@/components/landing/PartnerSplit";
import Models from "@/components/landing/Models";
import Sectors from "@/components/landing/Sectors";
import Capabilities from "@/components/landing/Capabilities";
import Marquee from "@/components/landing/Marquee";
import Process from "@/components/landing/Process";
import Pricing from "@/components/landing/Pricing";
import Comparison from "@/components/landing/Comparison";
import Leadership from "@/components/landing/Leadership";
import Faq from "@/components/landing/Faq";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import StackSection from "@/components/landing/StackSection";

const SECTIONS = [Hero, Statement, PartnerSplit, Models, Sectors, Capabilities, Marquee, Process, Pricing, Comparison, Leadership, Faq, Contact];

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-white text-[#0B132B] min-h-screen" data-testid="expante-app">
      <Nav />
      <main>
        {SECTIONS.map((Section, i) => (
          <StackSection key={i} z={i + 1}>
            <Section />
          </StackSection>
        ))}
      </main>
      <div style={{ position: "relative", zIndex: 20 }}>
        <Footer />
      </div>
    </div>
  );
}
